import { isCountryUSA } from "@faire/deprecated-retailer-visitor-shared/lib/countryUtils";
import { getSessionCountry } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getSessionCountry";

export const useIsLoggedOutHomepageV2 = () => {
  const sessionCountry = getSessionCountry();
  return isCountryUSA(sessionCountry);
};
